module.exports = __webpack_public_path__ + "static/media/ic_save.89756baa.svg";